import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewDa = () => {
    return <AnonymousView languageCode="da" />
}

export default AnonymousViewDa
